import React, { useState } from 'react';
import Lightbox from 'react-image-lightbox';
import s from './MainImage.module.css';
import ImagePlaceholder from '../imagePlaceholder/imagePlaceholder';

export function MainImage({
    previewUrl,
    inventoryGuid,
    setNewInventoryLog,
    setInventoryData,
    inventoryData,
    warehouseId,
    setImage,
}) {
    const [isOpen, setIsOpen] = useState(false);
    const images = [previewUrl];
    return (
        <div className={s.inventoryPhotoWrapper}>
            {previewUrl !== null && (
                <>
                    {isOpen && (
                        <Lightbox
                            reactModalStyle={{ overlay: { zIndex: 1300 } }}
                            mainSrc={previewUrl}
                            onCloseRequest={() => setIsOpen(false)}
                            imagePadding={100}
                            imageCaption={images.photoDate}
                        />
                    )}
                    <img
                        className={s.inventoryPhoto}
                        src={previewUrl}
                        alt="inventory-photo"
                        onClick={() => setIsOpen(true)}
                    />
                </>
            )}
            <ImagePlaceholder
                setInventoryData={setInventoryData}
                inventoryData={inventoryData}
                previewUrl={previewUrl}
                inventoryGuid={inventoryGuid}
                setNewInventoryLog={setNewInventoryLog}
                setImage={setImage}
                warehouseId={warehouseId}
            />
        </div>
    );
}
